import { default as ClickableRowsModule } from "./clickableRows-module";

export default ClickableRowsModule;
